import Controller from "./invoice.controller";
import template from "./invoice.html";

const invoice = {
  template,
  controller: Controller,
};

export default invoice;



// WEBPACK FOOTER //
// ./src/pages/invoice/invoice.component.js